var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterMarkFp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.22104 5.88832C4.59765 5.86654 4.47944 4.32967 4.49004 2.8889C4.5022 1.35459 4.70784 0.711346 5.12016 0.486851C5.41892 0.323861 6.41816 0.386135 6.46654 0.389211C7.83748 0.474806 8.375 1.39124 8.375 2.23925C8.375 3.91656 7.39387 4.0593 6.55914 4.57928C5.88427 4.99957 5.84883 5.88832 5.22104 5.88832Z",
    fill: "#00CA8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92443 0.990553C3.91848 0.520548 3.58247 0.440847 3.20119 0.407019C2.85302 0.375498 1.7917 0.355252 1.30281 0.430084C0.620962 0.535412 0.521115 1.68172 0.502232 2.93823C0.481539 4.34594 0.596129 5.84821 1.20943 5.88717C1.21332 5.88717 1.2172 5.88794 1.22082 5.88794C1.43318 5.89537 1.58011 5.80234 1.7022 5.6619C1.8812 5.45611 2.00484 5.14731 2.20505 4.90103C2.57107 4.45178 2.82121 4.33108 3.21024 4.0033C3.80311 3.50383 3.50435 2.88723 3.51729 2.4162C3.52711 2.07151 3.6386 1.84471 3.68775 1.7463C3.85847 1.4029 3.92676 1.18506 3.92443 0.990553Z",
    fill: "#00CA8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterMarkFp);
export default __webpack_public_path__ + "static/media/WaterMarkFP.a6d4b89f8dcf37e7180b95256ad7e93b.svg";
export { ForwardRef as ReactComponent };